module.exports = __webpack_public_path__ + "static/img/04022A_2_3_R_20200606_LC.726e545.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/04022A_2_3_R_20200606_LC.png
// module id = Bbmr
// module chunks = 0